import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { AtlassianIcon, AtlassianLogo } from '@atlaskit/logo';
import { N0, N800 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import { MobileTrigger } from '@atlassiansox/bxpkit-user-profile-dropdown';
import styled from '@emotion/styled';
import React from 'react';
import { useDevopsState } from '../';
import { messages } from '../messages';

export function DevopsHeader() {
  const { userInfo, switchAccountUrl, switchAccountOrigin } = useDevopsState();

  const { createAnalyticsEvent } = useAnalyticsEvents();

  function DevOpsLogoGA() {
    return (
      <DevopsLogoWrapper>
        <LogoText>
          <AtlassianLogo textColor={N0} iconColor={N0} className={'logo'} />
          <span className={'openDevOps'}>
            <SanitizedFormattedHtmlMessage {...messages.openDevOps} />
          </span>
        </LogoText>
        <LogoSubheaderText>
          <SanitizedFormattedHtmlMessage {...messages.devopsLogoSubheader} />
        </LogoSubheaderText>
      </DevopsLogoWrapper>
    );
  }
  function DevOpsLogoMobileGA() {
    return (
      <DevopsLogoMobileWrapper>
        <AtlassianIcon iconColor={N0} />
      </DevopsLogoMobileWrapper>
    );
  }

  function UserDisplay() {
    if (
      !userInfo ||
      !userInfo.isLoggedIn ||
      !userInfo.picture ||
      !userInfo.email
    ) {
      return null;
    }

    const onChangeAccount = () => {
      if (switchAccountOrigin) {
        createAnalyticsEvent({
          eventName: 'wac-signup-existing-user-switch',
          data: {
            switchAccountOrigin
          }
        }).fire();
      }
    };

    return (
      <LoggedInView data-testid="devops-account-switcher">
        <MobileTrigger
          userName={userInfo?.email}
          logOutUrl={switchAccountUrl}
          logOutMessage={messages.devopsSwitchAccounts}
          avatarSrc={userInfo?.picture}
          onClick={onChangeAccount}
        />
      </LoggedInView>
    );
  }

  return (
    <HeaderWrapper>
      <HeaderCenter>
        <Header>
          <DevOpsLogoMobileGA />
          <DevOpsLogoGA />
          <UserDisplay />
        </Header>
      </HeaderCenter>
    </HeaderWrapper>
  );
}

const HeaderWrapper = styled.div`
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  position: relative;
  width: 100%;
  height: 200px;
  color ${N0} !important;

  @media only screen and (max-width: 800px) {
    height: 65px;
    background-image: none;
    background-color: ${N800} !important;
  }
`;

const HeaderCenter = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0px auto 0px;
  padding: 48px 48px 0px 48px;

  @media only screen and (max-width: 800px) {
    padding: 0px 22px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-size: 44px;
  font-weight: 700;
  max-width: 360px;
  line-height: 42px;
  max-width: none;

  .atl-logo {
    display: none;
  }

  @media only screen and (max-width: 800px) {
    .atl-logo {
      display: block;
    }
  }
`;

const LoggedInView = styled.div`
  padding-left: 10px;
  padding-top: 17px;

  @media only screen and (max-width: 800px) {
    top: 32px;
  }
`;
const DevopsLogoWrapper = styled.div`
  color: ${N0};
  display: flex;
  flex-direction: column;
  line-height: 66px;
  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const DevopsLogoMobileWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 800px) {
    display: block;
    padding-top: 12px;
  }
`;

const LogoText = styled.div`
  @media only screen and (max-width: 800px) {
    display: none;
  }
  white-space: nowrap;
  font-size: 34px;
  font-weight: 600;
  margin-top: 2px;
  text-transform: uppercase;
  display: flex;
  align-items: center;

  .openDevOps {
    color: ${N0};
    margin-left: 1rem;
    font-size: 34px;
    line-height: 44px;
    font-weight: normal;
    text-transform: initial;
  }

  .logo {
    height: 38px;
  }
`;

const LogoSubheaderText = styled.div`
  @media only screen and (max-width: 800px) {
    display: none;
  }
  color: ${N0};
  margin-top: 1rem;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.3px;
  font-weight: normal;
  max-width: 595px;
`;
